import { useState } from "react";
import PickUpanddrops from "./PickUpanddrops";
import PickDropApp from "./PickDropApp";

const TABS = [
  { key: "app", label: "Portal" },
  { key: "portal", label: "App" },
];

const STORAGE_KEY = "pickDropSourceTab";

export default function PickDropTabs() {
  const [source, setSource] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "app" || saved === "portal" ? saved : "portal";
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: 0,
          marginBottom: 16,
          borderBottom: "2px solid #e5e7eb",
        }}
      >
        {TABS.map((tab) => {
          const active = source === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => {
                setSource(tab.key);
                localStorage.setItem(STORAGE_KEY, tab.key);
              }}
              style={{
                padding: "8px 22px",
                border: "none",
                borderBottom: active ? "2px solid #22c7b8" : "2px solid transparent",
                marginBottom: -2,
                background: "transparent",
                color: active ? "#0f766e" : "#64748b",
                fontWeight: active ? 600 : 500,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      {source === "app" ? <PickDropApp /> : <PickUpanddrops />}
    </>
  );
}
